import classNames from 'classnames';

import Icon, { IconTypes } from '@/components/Icon';

import * as styles from './styles.module.scss';

interface RoundProgressBarProps {
    percent: number;
    className?: string;
    icon?: IconTypes;
}

export default function RoundProgressBar({ percent, className, icon }: RoundProgressBarProps) {
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    if (percent === 0) percent = 1; // Minimum is 1% as looks better
    const strokeDashoffset = percent ? circumference - (percent / 100) * circumference : 0;

    return (
        <div className={classNames(styles.RoundProgressBar, className)} aria-label={`Progress: ${percent}%`}>
            <svg className={styles.progressSvg} viewBox="0 0 100 100">
                {/* Background circle */}
                <circle className={styles.backgroundCircle} cx="50" cy="50" r={radius} strokeWidth="8" fill="none" />
                {/* Progress circle */}
                <circle
                    className={styles.progressCircle}
                    cx="50"
                    cy="50"
                    r={radius}
                    strokeWidth="8"
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                />
            </svg>
            {icon && (
                <div className={styles.iconContainer}>
                    <Icon type={icon} className={styles.icon} />
                </div>
            )}
        </div>
    );
}
